export default __webpack_public_path__ + "static/media/user_profile.cbe6188b.svg";